import { createSlice } from "@reduxjs/toolkit";

// Backend page size (fixed)
const DEFAULT_PAGE_SIZE = 1;

const initialState = {
  status: null,
  search: null,
  cursor: 0,
  pagination: DEFAULT_PAGE_SIZE,
};

const inventorySpareLotListFilterSlice = createSlice({
  name: "inventorySpareLotListFilter",
  initialState,
  reducers: {
    /**
     * Set or update filters
     * Reset cursor when any filter changes
     */
    setInventorySpareLotListFilter: (state, action) => {
      const { status, search } = action.payload;
      let resetCursor = false;

      if (status !== undefined && state.status !== status) {
        state.status = status;
        resetCursor = true;
      }

      if (search !== undefined && state.search !== search) {
        state.search = search;
        resetCursor = true;
      }

      if (resetCursor) {
        state.cursor = 0;
      }
    },

    /** Used by infinite scroll */
    setInventorySpareLotListCursor: (state, action) => {
      state.cursor = action.payload;
    },

    /** Reset everything */
    clearInventorySpareLotListFilters: () => initialState,
  },
});

export const {
  setInventorySpareLotListFilter,
  setInventorySpareLotListCursor,
  clearInventorySpareLotListFilters,
} = inventorySpareLotListFilterSlice.actions;

/** Selector */
export const selectInventorySpareLotFilterState = (state) =>
  state.inventorySpareLotListFilter;

export default inventorySpareLotListFilterSlice.reducer;
